import gql from 'graphql-tag'

import { homepageBlocks } from '../blocks'
import {
  genericLinkFrag, image, locales,
  newsPicker,
  seo,
  videoMediaFrag
} from '../utils'

export const hpPage = `
  ... on homepage_Entry {
    ${locales}
    ${seo}
    title
    hero: homeHero {
      abstract
      formLink {
        label
        form {
          ... on FormInterface {
            handle
          }
        }
      }
      link: heroLink { ${genericLinkFrag} }
      news: ${newsPicker}
      imageMobile {
        ${image}
      }
      imageDesktop {
        ${image}
      }
      video { ${videoMediaFrag} }
    }
    blocks: homepageBlocks {
      ${homepageBlocks}
    }
  }
`

export const HOMEPAGE = gql`
  query HOMEPAGE($site: [String]) {
    entry(section: "homepage", site: $site) {
      ${hpPage}
    }
  }
`
